import { render, staticRenderFns } from "./PaymentCurrencyForm.vue?vue&type=template&id=51c7bb60&scoped=true"
import script from "./PaymentCurrencyForm.vue?vue&type=script&lang=ts"
export * from "./PaymentCurrencyForm.vue?vue&type=script&lang=ts"
import style0 from "./PaymentCurrencyForm.vue?vue&type=style&index=0&id=51c7bb60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c7bb60",
  null
  
)

export default component.exports